
















































// Vue
import { Component, Vue, Prop } from 'vue-property-decorator'

// components
import { Input, Radio, SwitchToggle } from '@/components/form'

// Vuelidate
import { Validations } from 'vuelidate-property-decorators'
import { validationMixin } from 'vuelidate'
import { required, minLength, minValue } from 'vuelidate/lib/validators'

// models
import { WorkDescriptionForm } from '@/models/config'

// constants
import { optionsStatus } from '@/constants'

// utils
import { loading, alerts } from '@/utils'

// services
import { WorkDescriptionService } from '@/services/config'

@Component({
    name: 'FormCreateEditWorkDescription',
    components: {
        Input,
        Radio,
        SwitchToggle
    },
    mixins: [validationMixin]
})
export default class FormCreateEditWorkDescription extends Vue {
    @Prop({ type: String, default: 'save' }) actionForm!: string
    @Prop({ required: true }) workDescription!: WorkDescriptionForm
    @Prop({ type: Number, default: null }) idEdit!: number|null

    optionsStatus = optionsStatus
    form: WorkDescriptionForm = {
        name: '',
        price: 0,
        is_active: true,
        is_group_piecework: false
    }

    nameOld = ''
    nameErrorUnique = ''

    created () {
        if (this.idEdit) {
            this.form = this.workDescription
        }
        this.nameOld = this.form.name
    }

    @Validations()
    validations () {
        return {
            form: {
                name: {
                    required,
                    minLength: minLength(2),
                    isUnique: async (value: string) => {
                        if (String(value) === this.nameOld) return true
                        this.nameErrorUnique = ''
                        const result = await WorkDescriptionService.validateName(value)
                        if (result.success) {
                            return true
                        }
                        this.nameErrorUnique = result.msg
                        return false
                    }
                },
                price: { required, minValue: minValue(0.01) },
                is_active: { required }
            }
        }
    }

    async save () {
        this.$v.$touch()
        if (!this.$v.$anyError) {
            loading('show')
            try {
                if (this.actionForm === 'update' && this.idEdit !== null) {
                    await WorkDescriptionService.update(this.idEdit, this.form)
                } else {
                    await WorkDescriptionService.create(this.form)
                }
                alerts.success()
                this.$v.$reset()
                this.form = {
                    name: '',
                    price: 0,
                    is_active: true,
                    is_group_piecework: false
                }
                this.$emit('save-success')
            } catch (e) {
                alerts.error('Se ha presentado errores en la operación')
            }
            loading('hide')
            this.$v.$reset()
        } else {
            alerts.error('Debe completar todos los campos requeridos')
        }
        loading('hide')
    }
}
